import React from 'react'

const UndoArrow = props => {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.03013 0.734375L0 4.32019L3.03013 7.90601L4.04018 6.71074L2.73438 5.16547H5C5.46901 5.16547 5.93342 5.27479 6.36673 5.48718C6.80003 5.69958 7.19374 6.01089 7.52538 6.40335C7.85702 6.7958 8.12009 7.26171 8.29957 7.77448C8.47905 8.28725 8.57143 8.83683 8.57143 9.39185C8.57143 10.5128 8.19515 11.5877 7.52538 12.3803C6.85561 13.1729 5.9472 13.6182 5 13.6182H3.57143V15.3088H5C6.32608 15.3088 7.59785 14.6854 8.53553 13.5757C9.47322 12.4661 10 10.9611 10 9.39185C10 8.61482 9.87067 7.84541 9.6194 7.12754C9.36812 6.40966 8.99983 5.75738 8.53553 5.20795C8.07124 4.65851 7.52005 4.22267 6.91342 3.92532C6.30679 3.62796 5.65661 3.47492 5 3.47492H2.73438L4.04018 1.92965L3.03013 0.734375Z"
        fill="black"
      />
    </svg>
  )
}

export default UndoArrow
